<script setup>
import {computed} from "vue";
import PostContainer from "../components/PostContainer.vue";

// ログインユーザー ID
const userId = loginUserId;

const props = defineProps({
  data: {
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

// データが広告なのか投稿 ID なのか
const isAd = computed(() => typeof props.data === 'string');
</script>

<template>
  <div :class="{lyMb16: isAd, lyPcHidden: isAd}">
    <p
      v-if="isAd"
      v-html="data"
      class="lyMaxW500px lyBlockCnt"
    ></p>
    <PostContainer
      v-else
      :login-user-id="userId"
      :post="data"
      container-type="list"
    />
  </div>
</template>
